core.component('datatableComponent', {
    templateUrl: 'components/datatable/datatable.html',
    controller: 'datatableComponentController',
    bindings: { tableCtrl:'=', tableFilter: '=' }
});

core.controller('datatableComponentController', ['$scope', 'coreLanguage', '$state', '$filter', 'coreFb', 'coreUtils', 'coreDialog', function($scope, $text, $state, $filter, $fb, $utils, $dialog) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.pageSizeOptions = [
        10,
        50,
        100,
        150,
        200,
        250
    ];

    $ctrl.currentPage = 1;
    
    const _excluirRegistro=(reg)=>{

        if(!$ctrl.tableObj.actions.enable.delete){
            return;
        }

        $dialog.show($text.deleteReg, $text.confirmDeletion, $text.yes, $text.no, null).then(()=>{
            $state.params.showGlobalLoading = {value:true};

            if(!reg.docPath){
                return;
            };

            $fb.db.del(reg.docPath).then(okay=>{
                $state.reload();
                return;
            });

        }).catch(e=>{});
    };

    const _excluirSelecionados=()=>{
        const registros = $ctrl.tableObj.data.filter((item)=>item.selected);

        if(!registros.length){
            return;
        }

        if(!$ctrl.tableObj.bulkActions.enable.delete){
            return;
        }

        $dialog.show($text.deleteReg, `Deseja excluir ${registros.length} contatos da lista?`, $text.yes, $text.no, null).then(async()=>{
            $state.params.showGlobalLoading = {value:true};

            for(let reg of registros){
                
                if(!reg.docPath){
                    continue;
                }

                await $fb.db.del(reg.docPath);
            }

            $state.reload();

            return;
        }).catch(e=>{});
    };
    
    const _downloadSelecionados=()=>{
        if(!$ctrl.tableObj.bulkActions.enable.download){
            return;
        }

        const registros = $ctrl.tableObj.data.filter((item)=>item.selected);

        const exportables = $ctrl.tableObj.columns.filter((item)=>item.export);
        const exportableFields = exportables.map((item)=>item.key);

        const content = [];

        for (let dados of registros){
            let conteudo = [];

            Object.keys(dados).forEach(key=>{
                let idx = exportableFields.indexOf(key);

                if(idx>-1){
                    let obj = dados[key];

                    if(exportables[idx].type === 'array'){
                        obj = obj.map((item)=>item.value).join(', ');
                    }else if(exportables[idx].type === 'date'){
                        obj = $filter('date')(obj, 'dd/MM/yyyy');
                    }else if(exportables[idx].type === 'badge'){
                        obj = obj.value;
                    };

                    conteudo.push(obj);
                }
            });
            
            content.push(conteudo);
        };

        content.unshift(exportables.map((item)=>item.title));

        const csv = $utils.createCsv(content, ";");

        const csvBlob = new Blob([csv]);

        $utils.downloadBlob(csvBlob, `${$state.current.name}_${new Date().toISOString()}.csv`);
        return;
    };

    $ctrl.nextPage = () => {
        if($ctrl.tableObj.currentPage < $ctrl.tableObj.pageCount){ $ctrl.tableObj.currentPage++; }
    };

    $ctrl.previousPage = () => {
        if($ctrl.tableObj.currentPage>1){ $ctrl.tableObj.currentPage--; }
    };

    $ctrl.setPage=(value)=>{
        $ctrl.tableObj.currentPage = parseInt(value);
    };

    $ctrl.selectAll=()=>{
        $ctrl.tableObj.data.forEach((item)=>{
            item.selected = $ctrl.allSelected;
        });
    };

    $ctrl.checkAllSelected=()=>{
        if($ctrl.allSelected){
            $ctrl.allSelected = $ctrl.tableObj.data.length === $ctrl.getSelectedLength();
        }
    };

    $ctrl.getSelectedLength=()=>{
        return $ctrl.tableObj.data.filter((item)=>item.selected).length;
    };

    $ctrl.getColspan=()=>{
        return $ctrl.tableObj.columns.length+1;
    };

    const tableDefaults = {
        showSelect:true,
        pageSize:50,
        pageCount:0,
        currentPage:1,
        columns:[],
        data:[],
        actions:{
            enable:{
                view:false,
                edit:false,
                duplicate:false,
                delete:true
            },
            view: null,
            edit: null,
            duplicate: null,
            delete:_excluirRegistro
        },
        bulkActions:{
            enable:{ 
                delete:true,
                download:true
            },
            deleteAll: _excluirSelecionados,
            download: _downloadSelecionados,
        }
    };

    $ctrl.$onInit=()=>{

        $ctrl.tableObj = {
            ...tableDefaults,
            ...$ctrl.tableCtrl,
            actions:{
                ...tableDefaults.actions,
                ...$ctrl.tableCtrl.actions,
                enable:{
                    ...tableDefaults.actions.enable,
                    ...$ctrl.tableCtrl.actions?.enable??null
                }
            },
            bulkActions:{
                ...tableDefaults.bulkActions,
                ...$ctrl.tableCtrl.bulkActions,
                enable:{
                    ...tableDefaults.bulkActions.enable,
                    ...$ctrl.tableCtrl.bulkActions?.enable??null
                }
            }
        };
        

        if(!!$ctrl.tableCtrl.paginationCtrl){
            ///Old pagination
            /* $scope.$watch('$ctrl.tableObj.pageSize', (newVal, oldVal) => {
                if((newVal && oldVal) && newVal !== oldVal){ 
                    $ctrl.tableCtrl.pageSize = newVal;
    
                    if($ctrl.tableObj.currentPage === 1){
                        $ctrl.tableCtrl.pageLast = false;
                    };
    
                    $ctrl.tableCtrl.paginationCtrl();
                };
            }); */
            
            $scope.$watch('$ctrl.tableObj.currentPage', (newVal, oldVal) => {
                if((newVal && oldVal) && newVal !== oldVal){ 
                    $ctrl.tableCtrl.pageSize += $ctrl.tableCtrl.pageSize;
                    $ctrl.tableCtrl.currentPage = $ctrl.tableObj.currentPage;

                    $ctrl.tableCtrl.paginationCtrl();
                };
            });
        }

    };
    
}]);